import { createFileRoute } from '@tanstack/react-router';

// The team type select alone, with no type chosen
export const Route = createFileRoute('/_authenticated/teams/')({});
